"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Transaction = function Transaction() {
  _classCallCheck(this, Transaction);

  this.level = 0;

  this.actions = [];
  this.animated = null;

  this.initialMap = null;
  this.finalMap = null;
  this.initialLayoutInfo = new Map();
  this.finalLayoutInfo = new Map();
  this.removed = new Map(); // views that no longer exist after the update
  this.toRemove = new Map(); // views that still exist but are no longer visible

  this.selection = null;
};

exports.default = Transaction;